import React from "react";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";

import PageBanner from "./../layouts/PageBanner";
import bgImage from "./../assets/images/banner/bnr4.jpg";
import project3 from "./../assets/images/project/custom_pic1.png";
import project2 from "./../assets/images/project/custom_pic2.png";
import project6 from "./../assets/images/project/custom_pic6.png";
import UpdateBlog from "../components/Home/UpdateBlog";

const accordBlog = [
  { title: "Cras turpis felis, elementum sed mi at arcu ?" },
  { title: "Vestibulum nibh risus, in neque eleifendulputate ?" },
  { title: "Donec maximus, sapien id auctor ornare ?" },
];

const supportersFaq = [
  {
    title: "What do I do with my coin balance?",
    content: `The coins you have act as votes that you can give to different projects 
and you can divide them as you wish. Due to some limitations, there is no way to increase your coin balance`,
  },
  {
    title: "What do I benefit from supporting the projects?",
    content: `You will receive volunteering hours if you offer services or connections`,
  },
  {
    title: "How will my contribution help the entrepreneurs?",
    content: `Your efforts, no matter how small, will be of great help. Whether by volunteering 
or simply connecting the entrepreneurs with relevant people, you'll make their journey much more achievable`,
  },
];

const entrepreneursFaq = [
  {
    title: "What do I benefit from the coins I'm given?",
    content: `They act as votes which will be compared between the different projects 
to see which has gained the most support in terms of votes/coins. It also motivates you 
when you notice many people backing your project`,
  },
  {
    title:
      "If I am offered a connection, how do I know that they’re safe or relevant?",
    content: `The school administration checks with the provided connection 
to ensure it's appropriate and relevant to your idea and goals before you talk or meet with them`,
  },
  {
    title: "How can I notify supporters of the tasks I need help with?",
    content: `Send us an email at support@kaf25.org and we’ll make sure the students 
know about this volunteering opportunity`,
  },
];

const othersFaq = [
  {
    title:
      "What will the mentors/connections benefit from helping the entrepreneurs?",
    content: `They will benefit by receiving volunteer hours, as well as recognition 
and acknowledgment from the school`,
  },
  {
    title:
      "Can a mentor/connection support projects by providing physical or financial resources?",
    content: `Any contribution will be welcomed, though some may need 
to be discussed with the school administration`,
  },
  {
    title: "Who can participate on Kaf?",
    content: `Kaf is primarily designed for students within the school community, 
with entrepreneurs being students or senior entrepreneurs, and supporters, mentors, and investors 
being peers, teachers, and family members`,
  },
];

const Faq = () => {
  function isScrolledIntoView(elem) {
    const spliBox = document.querySelectorAll(elem);
    spliBox.forEach(myFunction);
    function myFunction(item, index) {
      console.log("splitbox", item);
      const docViewTop = window.scrollY;
      const docViewBottom = docViewTop + window.innerHeight;
      let elemTop = item.getBoundingClientRect().top + docViewTop;
      const elemBottom = elemTop + item.offsetHeight;
      if (elemBottom <= docViewBottom && elemTop >= docViewTop) {
        item.classList.add("split-active");
      }
    }
  }
  window.addEventListener("scroll", () => {
    isScrolledIntoView(".split-box");
  });
  return (
    <>
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="Faq" background={bgImage} />
        <section className="content-inner">
          <div className="container">
            <div className="row align-items-center flex-column-reverse flex-lg-row">
              <div className="col-lg-6 align-self-center">
                <div className="section-head m-b30">
                  <h2 className="title">Supporters</h2>
                  <p>
                    Frequently asked questions regarding supporting projects
                  </p>
                </div>
                <Accordion
                  className="accordion dz-accordion accordion-sm"
                  id="accordionFaq1"
                >
                  {supportersFaq.map((item, index) => (
                    <Accordion.Item
                      className="accordion-item"
                      key={index}
                      eventKey={index}
                    >
                      <Accordion.Header as="h2" id="headingOne1">
                        {item.title}
                        <span className="toggle-close"></span>
                      </Accordion.Header>
                      <div
                        id="collapseOne1"
                        className="accordion-collapse "
                        eventKey={index}
                      >
                        <Accordion.Body>
                          <p className="m-b0">{item.content}</p>
                        </Accordion.Body>
                      </div>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
              <div className="col-lg-6 order-lg-2 order-1 m-b30">
                <div className="dz-media split-box rounded">
                  <div>
                    <img src={project3} alt="FAQ Image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-light content-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 m-b30">
                <div className="dz-media split-box rounded">
                  <div>
                    <img src={project2} alt="FAQ Image" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 align-self-center m-b10">
                <div className="section-head m-b30">
                  <h2 className="title">Entrepreneurs</h2>
                  <p>Frequently asked questions regarding creating projects</p>
                </div>
                <Accordion
                  className="accordion dz-accordion accordion-sm"
                  id="accordionFaq1"
                >
                  {entrepreneursFaq.map((item, index) => (
                    <Accordion.Item
                      className="accordion-item"
                      key={index}
                      eventKey={index}
                    >
                      <Accordion.Header as="h2" id="headingOne1">
                        {item.title}
                        <span className="toggle-close"></span>
                      </Accordion.Header>
                      <div
                        id="collapseOne1"
                        className="accordion-collapse "
                        eventKey={index}
                      >
                        <Accordion.Body>
                          <p className="m-b0">{item.content}</p>
                        </Accordion.Body>
                      </div>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </section>
        <section className="content-inner-2">
          <div className="container">
            <div className="row align-items-center flex-column-reverse flex-lg-row">
              <div className="col-lg-6 align-self-center">
                <div className="section-head m-b30">
                  <h2 className="title">Others</h2>
                  <p>Frequently asked questions regarding everything else</p>
                </div>
                <Accordion
                  className="accordion dz-accordion accordion-sm"
                  id="accordionFaq1"
                >
                  {othersFaq.map((item, index) => (
                    <Accordion.Item
                      className="accordion-item"
                      key={index}
                      eventKey={index}
                    >
                      <Accordion.Header as="h2" id="headingOne1">
                        {item.title}
                        <span className="toggle-close"></span>
                      </Accordion.Header>
                      <div
                        id="collapseOne1"
                        className="accordion-collapse "
                        eventKey={index}
                      >
                        <Accordion.Body>
                          <p className="m-b0">{item.content}</p>
                        </Accordion.Body>
                      </div>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
              <div className="col-lg-6 order-lg-2 order-1 m-b30">
                <div className="dz-media split-box rounded">
                  <div>
                    <img src={project6} alt="FAQ Image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <div className="call-action style-1 content-inner-1">
                    <div className="container">
                        <UpdateBlog />
                    </div>
                </div> */}
      </div>
    </>
  );
};

export default Faq;
